export const enum FieldName {
  // only for business accounts
  Company = 'company',
  // regular address fields
  Title = 'title',
  FirstName = 'firstName',
  LastName = 'lastName',
  Phone = 'phone',
  StreetAndNumber = 'streetAndNumber',
  DigiCode = 'digicode',
  ShowAddressLine2 = 'showAddressLine2',
  AddressLine2 = 'addressLine2',
  Zip = 'zip',
  City = 'city',
  IsBillingSameAsShipping = 'isBillingSameAsShipping',
  // billing address specific fields
  CountryCode = 'countryCode',
  // tax-id specific fields
  SendInvoiceViaEmail = 'sendInvoiceViaEmail',
  TaxId = 'taxId',
  // guest checkout specific fields
  EmailAddress = 'emailAddress',
  RegisterAccount = 'registerAccount',
  Password = 'password',
  NewsletterSubscription = 'newsletterSubscription',
}
